const SITE = "https://www.dioscuro.com";

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Dioscuro",
  url: SITE,
  logo: `${SITE}/images/icon.png`,
  description:
    "Senior DevOps embedded into your team. AWS, GCP, Kubernetes, Terraform, CI/CD, observability, FinOps.",
  founder: {
    "@type": "Person",
    name: "Fabio Palumbo",
    jobTitle: "Founder & DevOps Architect",
    sameAs: ["https://www.linkedin.com/in/fppalumbo/"],
  },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "sales",
    email: "fabio@dioscuro.com",
    url: "https://cal.com/fabio-dioscuro/intro",
  },
  sameAs: ["https://www.linkedin.com/company/dioscuro-devops/"],
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Dioscuro",
  url: SITE,
};

export const personJsonLd = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Fabio Palumbo",
  jobTitle: "Founder & DevOps Architect",
  url: `${SITE}/about`,
  worksFor: { "@type": "Organization", name: "Dioscuro" },
  sameAs: ["https://www.linkedin.com/in/fppalumbo/"],
};

const tier = (name, target, priceUSD, hours, slaHours) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "DevOps as a Service",
  name: `Dioscuro ${name}`,
  description: `${target}. ${hours} hours/month with a ${slaHours} response SLA.`,
  provider: { "@type": "Organization", name: "Dioscuro" },
  areaServed: "Worldwide",
  offers: {
    "@type": "Offer",
    price: priceUSD,
    priceCurrency: "USD",
    url: `${SITE}/pricing`,
    availability: "https://schema.org/InStock",
  },
});

export const serviceJsonLd = [
  tier("Starter", "Setup help for early-stage teams", "1000", 20, "next-business-day"),
  tier("Growth", "Embedded DevOps for product teams without K8s expertise", "3500", 40, "8-hour"),
  tier("Scale", "Dedicated DevOps owners for scale-up infrastructure", "6000", 80, "4-hour"),
];
